import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
/*
 * Copyright (c) 2023 LS ELECTRIC Co. Ltd. All Reserved.
 */
/*******************************************************************
 * @author HyeongJin Oh
 * @contact hjoh@detech.co.kr
 * @date 2023-07-20
 * @brief SEI 설비유형 Management  개발
 *
 ********************************************************************/
import { useState } from "react";
// recoil
import { useRecoilValue } from "recoil";
import { checkSheetState, spgState } from "../../../recoil/menuState";
//utils
import { useOutletContext } from "react-router-dom";
import { useTrans } from "../../../utils/langs/useTrans";
import SpgTree from "./SpgTree";
import SpgCreate from "./companys/SpgCreate";
import SpgUpdate from "./companys/SpgUpdate";
import SpgView from "./companys/SpgView";
import SpgDefalutCreate from "./defalut/SpgDefalutCreate";
import SpgDefalutUpdate from "./defalut/SpgDefalutUpdate";
import SpgDefalutView from "./defalut/SpgDefalutView";
function SpgMain(props) {
    const t = useTrans();
    //recoil
    const checksheet = useRecoilValue(checkSheetState);
    const spgs = useRecoilValue(spgState);
    //props
    const { handleOpenPop } = useOutletContext();
    const checksheetName = ["LS 정밀점검", "고객향 점검" /* "직무고시 점검" */];
    const [workMode, setWorkMode] = useState("READ"); //READ,C
    const [spgType, setSpgType] = useState(checksheetName[0]);
    return (_jsx(_Fragment, { children: _jsxs("div", Object.assign({ className: "box-wrap" }, { children: [_jsxs("div", Object.assign({ className: "box treebar pushy-menutype type2" }, { children: [_jsx("div", Object.assign({ className: "box__header" }, { children: _jsxs("p", Object.assign({ className: "list-info" }, { children: [_jsx("span", { children: t("라벨.활성화") }), _jsx("span", Object.assign({ className: "dis" }, { children: t("라벨.비활성화") }))] })) })), _jsx(SpgTree, { checksheetName: checksheetName, setWorkMode: setWorkMode, workMode: workMode, spgType: spgType, setSpgType: setSpgType })] })), workMode == "READ" && spgs.spgId > 0 && checksheet.sheetType == checksheetName[0] && (_jsx(SpgDefalutView, { handleOpenPop: handleOpenPop, checksheetName: checksheetName, setWorkMode: setWorkMode })), workMode == "CREATE" && checksheet.sheetType == checksheetName[0] && (_jsx(SpgDefalutCreate, { checksheetName: checksheetName, setWorkMode: setWorkMode })), workMode == "UPDATE" && spgs.spgId > 0 && checksheet.sheetType == checksheetName[0] && (_jsx(SpgDefalutUpdate, { checksheetName: checksheetName, setWorkMode: setWorkMode })), workMode == "READ" && spgs.companySpgId > 0 && checksheet.sheetType == checksheetName[1] && (_jsx(SpgView, { handleOpenPop: handleOpenPop, checksheetName: checksheetName, setWorkMode: setWorkMode, setSpgType: setSpgType })), workMode == "CREATE" && checksheet.sheetType == checksheetName[1] && (_jsx(SpgCreate, { checksheetName: checksheetName, setWorkMode: setWorkMode })), workMode == "UPDATE" && spgs.companySpgId > 0 && checksheet.sheetType == checksheetName[1] && (_jsx(SpgUpdate, { checksheetName: checksheetName, setWorkMode: setWorkMode }))] })) }));
}
export default SpgMain;
